var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 14
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("职级名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "50%"
    },
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("销售分佣方式"),
      prop: "type"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "50%"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("销售分佣方式")
    },
    model: {
      value: _vm.dataFrom.type,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "type", $$v);
      },
      expression: "dataFrom.type"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "2"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("根据产品比例")) + " ")]), _c("a-select-option", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("固定比例")) + " ")])], 1)], 1), _vm.dataFrom.type == 1 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("固定比例"),
      prop: "proportion"
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "50%"
    },
    model: {
      value: _vm.dataFrom.proportion,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "proportion", $$v);
      },
      expression: "dataFrom.proportion"
    }
  }), _c("span", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("%")])], 1) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("增员绑定"),
      prop: "add"
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.dataFrom.add,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "add", $$v);
      },
      expression: "dataFrom.add"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("邀请绑定")) + " ")])], 1), _c("div", [_vm._v(_vm._s(_vm.$t("邀请绑定：代理人扫码或手动填写邀请人工号绑定上下级关系，绑定后不可变更")))]), _c("div", {
    staticStyle: {
      color: "red"
    }
  }, [_vm._v(_vm._s(_vm.$t("绑定关系创建后不可修改")))])], 1), _vm.dataFrom.add == 1 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("增员比例"),
      prop: "proportion2"
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "50%"
    },
    model: {
      value: _vm.dataFrom.proportion2,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "proportion2", $$v);
      },
      expression: "dataFrom.proportion2"
    }
  }), _c("span", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("%")])], 1) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("晋级方式"),
      prop: "mode"
    }
  }, [_c("a-checkbox-group", {
    on: {
      change: _vm.modeChange
    },
    model: {
      value: _vm.dataFrom.mode,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "mode", $$v);
      },
      expression: "dataFrom.mode"
    }
  }, [_c("a-checkbox", {
    attrs: {
      value: "1",
      name: "type"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("手动晋级")) + " ")]), _c("a-checkbox", {
    attrs: {
      value: "2",
      name: "type"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("自动晋级")) + " ")])], 1), _c("div", {
    staticStyle: {
      color: "red"
    }
  }, [_vm._v(_vm._s(_vm.$t("晋级方式仅支持逐级晋级")))])], 1), _vm.modeType ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("自动晋级规则"),
      prop: "promotion"
    }
  }, [_c("a-checkbox-group", {
    model: {
      value: _vm.dataFrom.promotion,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "promotion", $$v);
      },
      expression: "dataFrom.promotion"
    }
  }, _vm._l(_vm.promotionList, function (item, index) {
    return _c("a-checkbox", {
      key: index,
      staticClass: "infoBox",
      attrs: {
        value: item.value,
        name: "type"
      }
    }, [_c("div", {
      staticClass: "infoBox"
    }, [_vm._v(" " + _vm._s(_vm.$t("连续")) + " "), _c("a-input", {
      staticClass: "input",
      model: {
        value: item.name,
        callback: function ($$v) {
          _vm.$set(item, "name", $$v);
        },
        expression: "item.name"
      }
    }), _vm._v(" " + _vm._s(_vm.$t("月")) + " "), _c("a-select", {
      staticClass: "input",
      attrs: {
        placeholder: _vm.$t("请选择")
      },
      model: {
        value: item.type,
        callback: function ($$v) {
          _vm.$set(item, "type", $$v);
        },
        expression: "item.type"
      }
    }, [_c("a-select-option", {
      attrs: {
        value: "2"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("每月")) + " ")]), _c("a-select-option", {
      attrs: {
        value: "1"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("累计")) + " ")])], 1), _vm._v(_vm._s(_vm.$t("出单")) + " "), _c("a-select", {
      staticClass: "input",
      attrs: {
        placeholder: _vm.$t("请选择")
      },
      model: {
        value: item.type2,
        callback: function ($$v) {
          _vm.$set(item, "type2", $$v);
        },
        expression: "item.type2"
      }
    }, [_c("a-select-option", {
      attrs: {
        value: "2"
      }
    }, [_vm._v(" > ")]), _c("a-select-option", {
      attrs: {
        value: "1"
      }
    }, [_vm._v(" < = ")])], 1), _c("a-input", {
      staticClass: "input",
      model: {
        value: item.name2,
        callback: function ($$v) {
          _vm.$set(item, "name2", $$v);
        },
        expression: "item.name2"
      }
    }), _vm._v(_vm._s(item.word === "元" ? _vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId)) : _vm.$t(item.word)) + " ")], 1)]);
  }), 1)], 1) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("降级方式"),
      prop: "mode2"
    }
  }, [_c("a-checkbox-group", {
    on: {
      change: _vm.modeChange2
    },
    model: {
      value: _vm.dataFrom.mode2,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "mode2", $$v);
      },
      expression: "dataFrom.mode2"
    }
  }, [_c("a-checkbox", {
    attrs: {
      value: "1",
      name: "type"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("手动降级")) + " ")]), _c("a-checkbox", {
    attrs: {
      value: "2",
      name: "type"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("自动降级")) + " ")])], 1), _c("div", {
    staticStyle: {
      color: "red"
    }
  }, [_vm._v(_vm._s(_vm.$t("降级方式仅支持逐级降级")))])], 1), _vm.modeType2 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("自动降级规则"),
      prop: "promotion2"
    }
  }, [_c("a-checkbox-group", {
    model: {
      value: _vm.dataFrom.promotion2,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "promotion2", $$v);
      },
      expression: "dataFrom.promotion2"
    }
  }, _vm._l(_vm.promotionList2, function (item, index) {
    return _c("a-checkbox", {
      key: index,
      staticClass: "infoBox",
      attrs: {
        value: item.value,
        name: "type"
      }
    }, [_c("div", {
      staticClass: "infoBox"
    }, [_vm._v(" " + _vm._s(_vm.$t("连续")) + " "), _c("a-input", {
      staticClass: "input",
      model: {
        value: item.name,
        callback: function ($$v) {
          _vm.$set(item, "name", $$v);
        },
        expression: "item.name"
      }
    }), _vm._v(" " + _vm._s(_vm.$t("月")) + " "), _c("a-select", {
      staticClass: "input",
      attrs: {
        placeholder: _vm.$t("请选择")
      },
      model: {
        value: item.type,
        callback: function ($$v) {
          _vm.$set(item, "type", $$v);
        },
        expression: "item.type"
      }
    }, [_c("a-select-option", {
      attrs: {
        value: "2"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("每月")) + " ")]), _c("a-select-option", {
      attrs: {
        value: "1"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("累计")) + " ")])], 1), _vm._v(_vm._s(_vm.$t("出单")) + " "), _c("a-select", {
      staticClass: "input",
      attrs: {
        placeholder: _vm.$t("请选择")
      },
      model: {
        value: item.type2,
        callback: function ($$v) {
          _vm.$set(item, "type2", $$v);
        },
        expression: "item.type2"
      }
    }, [_c("a-select-option", {
      attrs: {
        value: "2"
      }
    }, [_vm._v(" > ")]), _c("a-select-option", {
      attrs: {
        value: "1"
      }
    }, [_vm._v(" < = ")])], 1), _c("a-input", {
      staticClass: "input",
      model: {
        value: item.name2,
        callback: function ($$v) {
          _vm.$set(item, "name2", $$v);
        },
        expression: "item.name2"
      }
    }), _vm._v(_vm._s(item.word === "元" ? _vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId)) : _vm.$t(item.word)) + " ")], 1)]);
  }), 1)], 1) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      "wrapper-col": {
        span: 14,
        offset: 4
      }
    }
  }, [_c("a-button", {
    attrs: {
      type: "add"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("确认")) + " ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };